import { P } from "@itpi/react-components";
import React, { useContext, useEffect, useState } from "react";
import ReactGA from "react-ga";
import { Page } from "../components/Page";
import AuthContext from "../context/AuthContext";
import TeacherLaughingWithStudents from "../assets/TeacherLaughingWithStudents.jpg";
import { Link } from "react-router-dom";
import { Routes } from "../App";
import EntrecompImage from "../assets/Entrecomp-image.jpg";
import QuestionsSVG from "../assets/undraw_questions.svg";
import DataSVG from "../assets/undraw_data.svg";
import TaskSVG from "../assets/undraw_task.svg";

const Home: React.FC<{}> = () => {
  const { token, groups, login } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean | Error>(false);

  useEffect(() => {
    ReactGA.pageview("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          backgroundImage: `url(${TeacherLaughingWithStudents})`,

          backgroundPosition: "center center",
          backgroundSize: "cover",
          minHeight: "calc(100vh - 200px)",
          boxShadow: "0 4px 11px rgb(124 146 169 / 50%)",
          position: "relative",
        }}
      >
        <div
          style={{
            background: "linear-gradient(to right, #b5121b, #FF7372)",
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: 0.96,
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",

              textAlign: "center",
            }}
          >
            <h1 style={{ color: "white" }}>Are you EntreCompetent?</h1>
            <h2 style={{ color: "white", fontWeight: "lighter", fontSize: 18 }}>
              (Hint: yes you are)
            </h2>
            <div>
              <button
                onClick={() => login()}
                style={{
                  borderRadius: 50,
                  padding: 20,
                  fontSize: 20,
                  margin: 20,
                  color: "black",
                  backgroundColor: "#06d19c",
                  border: "none",
                  opacity: 1,
                }}
              >
                Log In
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 style={{ marginBottom: 20 }}>
            What do you mean, 'EntreCompetent'?
          </h2>
          <p style={{ maxWidth: "80ch", fontSize: 16, textAlign: "center" }}>
            EntreComp is shorthand for the European Entrepreneurship Competence
            Framework. This framework describes what it means to be
            'entrepreneurial' in terms of 15 distinct areas of competence -
            skills, capabilities and mindsets - organised within three thematic
            areas:
          </p>
          <img
            src={EntrecompImage}
            alt="Diagram listing the different components of the entre comp system"
            style={{ maxWidth: 450 }}
          />
        </div>
      </div>

      <div
        style={{
          padding: "120px 30px",
          textAlign: "center",
          backgroundColor: "#f7f7f7",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <table
          className="table"
          id="flower"
          style={{
            textAlign: "center",
            fontSize: 16,
            borderCollapse: "separate",
            borderSpacing: 2,
          }}
        >
          <colgroup>
            <col span={1} style={{ backgroundColor: "#65959c"}} />
            <col span={1} style={{ backgroundColor: "#dc7d41"}} />
            <col span={1} style={{ backgroundColor: "#8ebf6d"}} />
          </colgroup>
          <tbody style={{color:"black"}}>
            <tr>
              <th>Ideas &amp; Opportunities</th>
              <th>Resources</th>
              <th>Into Action</th>
            </tr>
            <tr>
              <td>Spotting opportunities</td>
              <td>Mobilising others</td>
              <td>Taking the initiative</td>
            </tr>
            <tr>
              <td>Creativity</td>
              <td>Financial &amp; economic literacy</td>
              <td>Planning &amp; management</td>
            </tr>
            <tr>
              <td>Vision</td>
              <td>Mobilising resources</td>
              <td>Coping with ambiguity &amp; uncertainty</td>
            </tr>
            <tr>
              <td>Valuing ideas</td>
              <td>Motivation &amp; perseverance</td>
              <td>Working with others</td>
            </tr>
            <tr>
              <td>Ethical &amp; sustainable thinking</td>
              <td>Self-awareness &amp; self-efficacy</td>
              <td>Learning through experience</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          The extent to which you can describe your own capabilities in each of
          these areas reflects your own levels of entrepreneurial competence.
          Without necessarily realising it, throughout your life to date you
          have already learned things and experienced situations that have
          enabled you to begin developing in all these areas. From some of the
          titles alone, you may already be able thing of times you've done these
          things.
        </p>
        <p style={{}}>
          This video will help you to understand why this framework was
          developed and how it might be used:
        </p>

        <iframe
          width="560"
          height="315"
          src="https://www.youtube-nocookie.com/embed/UwZPcJky0Ko"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",

          backgroundColor: "#f7f7f7",
        }}
      >
        <img alt="" src={QuestionsSVG} style={{ maxWidth: 220 }} />
        <h2 style={{ margin: 20, textAlign: "center" }}>
          But I don't want to be an entrepreneur; why do I need to be
          EntreCompetent?
        </h2>
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          It might help to think of your entrepreneurial competencies as a
          toolkit that enables you to go out into the world and create value -
          for yourself and for others - by imagining and bringing to life
          sustainable solutions to real problems, large or small, local or
          global. This is something that entrepreneurs do, but it's also
          increasingly what employers want from their staff and what communities
          need from their members. When combined with the subject specific
          knowledge and skills you develop throughout your formal education
          journey, and the unique life experience you acquire along the way,
          entrepreneurial competencies can be extremely powerful, particularly
          in giving you the confidence to take practical action.
        </p>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img alt="" src={DataSVG} style={{ maxWidth: 220 }} />
        <h2 style={{ margin: 20, textAlign: "center" }}>
          OK, so how I can use this framework?
        </h2>
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          Our aim is to help you to recognise your own entrepreneurial strengths
          and weaknesses, in order that you can more independently define your
          development objectives and take practical steps towards them, whether
          it be through study and research, taking time to practise and gain
          experience, or by joining up with others whose strengths and
          weaknesses complement your own. The first step though, is to establish
          a baseline understanding of where you are now, in order that you can
          more easily recognise and measure your growth and progress over time.
          To do this, we have developed ECHOâ€¦the Entrepreneurial Competencies
          Heutagogical Organiser.
        </p>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",

          backgroundColor: "#f7f7f7",
        }}
      >
        <img alt="" src={TaskSVG} style={{ maxWidth: 220 }} />
        <h2 style={{ margin: 20, textAlign: "center" }}>Heuta-what-now??</h2>
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          Heutagogy (pron: <strong>hyoo</strong>-tuh-goh-jee) is the theory and
          practice of self-directed learning (citation). Your entrepreneurial
          learning journey is one you will take yourself, for the rest of your
          life, so you need to not only know how to what you need to learn, but
          how to learn it. As entrepreneurial learning is about cycles of
          action, reflection and adaptation, it's not something someone else can
          do for you. Starting to own your personal and professional development
          now is essential, and this self-assessment tool will help prepare you
          for planning and organising this.
        </p>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img alt="" src={DataSVG} style={{ maxWidth: 220 }} />
        <h2 style={{ margin: 20, textAlign: "center" }}>
          I see. So, who can use ECHO?
        </h2>
        <div>
          <p style={{ maxWidth: "80ch", fontSize: 16 }}>
            If you are already signed up to either our Start-up Validation
            Programme, or our Engagement Academy, you will be asked to undertake
            a self-assessment to establish your baseline, and to re-measure
            periodically, e.g. at the end of the programme, in order to monitor
            growth and progress, and to define new development plans.
          </p>
          <p style={{ maxWidth: "80ch", fontSize: 16 }}>
            Otherwise, you may simply be curious, in which case, please feel
            welcome to give it a try!
          </p>
        </div>
      </div>

      <div
        style={{
          background: "linear-gradient(to left, #b5121b, #FF7372)",
          padding: "90px 30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h2 style={{ color: "white" }}>Get Started Now</h2>
        <p style={{ color: "white" }}>Log in to take the ECHO test!</p>
        <button
          onClick={() => login()}
          style={{
            borderRadius: 50,
            padding: 20,
            fontSize: 20,
            margin: 20,
            color: "black",
            backgroundColor: "#06d19c",
            border: "none",
            opacity: 1,
          }}
        >
          Log In
        </button>
      </div>
    </div>
  );
};

export default Home;
